import React from 'react';

import './Switcher.scss';

const Switcher = ({ isChecked, setIsChecked }) => {
  const handleSwitchChange = async (e) => {
    const value = Number(e.target.checked);
    setIsChecked(value);
  };

  return (
    <label className="custom-switch">
      <input type="checkbox" checked={isChecked} onChange={handleSwitchChange} className="custom-switch-input" />
      <span className="custom-switch-slider" />
    </label>
  );
};

export default Switcher;
